import MaskedView from '@react-native-masked-view/masked-view';
import { LinearGradient } from 'expo-linear-gradient';
import { Platform, Text } from 'react-native';

const GradientText = ({ children, style, colors, ...props }) => {
  if (Platform.OS === 'web') {
    return (
      <Text
        {...props}
        style={[
          style,
          {
            backgroundImage: `linear-gradient(to bottom, ${colors.join(', ')})`,
            WebkitBackgroundClip: 'text',
            color: 'transparent',
          },
        ]}
      >
        {children}
      </Text>
    );
  }

  return (
    <MaskedView
      maskElement={
        <Text {...props} style={[style, { color: 'black' }]}>
          {children}
        </Text>
      }
    >
      <LinearGradient colors={colors} start={{ x: 0.5, y: 0 }} end={{ x: 0.5, y: 1 }}>
        <Text {...props} style={[style, { opacity: 0 }]}>
          {children}
        </Text>
      </LinearGradient>
    </MaskedView>
  );
};

export default GradientText;
